import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CamelCasePipe } from '../../../pipes/camel-case.pipe';
import { AppDatePipe } from '../../../pipes/app-date.pipe';

@Component({
    selector: 'app-alert-cancelar-pedido',
    templateUrl: './alert-cancelar-pedido.component.html',
    styleUrls: ['./alert-cancelar-pedido.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CamelCasePipe, AppDatePipe]
})
export class AlertCancelarPedidoComponent {

  @Input() alertCancelarPedido: boolean = false;
  @Output() alertCancelarPedidoFechou = new EventEmitter();
  @Input() dadosPedido: any = null;
  @Input() dadosCancelamento: any = null;
  @Output() alertCancelarPedidoConfirmou = new EventEmitter();
  clicouConfirmar: boolean = false;

  constructor() { }

  confirmarCancelamento() {
    this.clicouConfirmar = true;
    this.alertCancelarPedidoConfirmou.emit('Confirmou');
  }

  fecharAlertCancelarPedido() { 
    this.alertCancelarPedidoFechou.emit('Fechou');
  }

}
